export default __webpack_public_path__ + "static/13-969a6a22e387abc84e7b84a03769a3d2.png";